import {Component, Input, OnInit} from '@angular/core';
import {Project} from '../model/project';
import {Questionnaire} from '../model/questionnaire';
import {Terminal} from '../model/terminal';
import {ProjectService} from '../project/project.service';
import {ClickEvent} from '../project/pagination/pagination.component';
import {DataNavigationState} from '../model/data-navigation-state';
import {ActivatedRoute, Router} from '@angular/router';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';


@Component({
  selector:'search-component',
  template:`
    <div class="container demo">

      <div>
      <div class="dropdown" style="float: left;">
        <a class="btn btn-outline-info dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{this.selectedResultsPerPage}}
        </a>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <li class="dropdown-item" style="list-style: none" value="25" (click)="onSelected($event)">25</li>
          <li class="dropdown-item" style="list-style: none" value="50" (click)="onSelected($event)">50</li>
          <li class="dropdown-item" style="list-style: none" value="75" (click)="onSelected($event)">75</li>
          <li class="dropdown-item" style="list-style: none" value="100" (click)="onSelected($event)">100</li>
        </div>
      </div>
      <div style="float: left; padding-left: 20px;padding-top: 10px;">Advanced Search and filter  <i class="fas fa-filter"></i></div>
      </div>
      <table class="datatable table table-striped table-bordered">
        <thead  class="thead-dark">
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Date</th>
          <th>Tag</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td><div id="custom-search-input" class="input-group col-md-12">
            <input style="background-color: #fff8be;" type="text" class="form-control input-lg" placeholder="{{'nom eg: Winter'}}" [(ngModel)]="nom" />
            <div class="input-group-append">
              <span><i style="padding-top:15px;padding-left:10px;" class="fas fa-search"></i></span>
            </div>
          </div></td>
          <td><div id="custom-search-input" class="input-group col-md-12">
            <input style="background-color: #fff8be;" type="text" class="form-control input-lg" placeholder="{{'type eg:android'}}" [(ngModel)]="type" />
            <div class="input-group-append">
              <span><i style="padding-top:15px;padding-left:10px;" class="fas fa-search"></i></span>
            </div>
          </div></td>
          <td><div id="custom-search-input" class="input-group col-md-12">
            <input style="background-color: #fff8be;" type="text" class="form-control input-lg" placeholder="{{'date (YYYY-MM-DD) eg:2018-12-04'}}" [(ngModel)]="datum" />
            <div class="input-group-append">
              <span><i style="padding-top:15px;padding-left:10px;" class="fas fa-search"></i></span>
            </div>
          </div></td>
          <td><div id="custom-search-input" class="input-group col-md-12">
            <input style="background-color: #fff8be;" type="text" class="form-control input-lg" placeholder="{{'tags eg: fusion,camera ring'}}" [(ngModel)]="tag" />
            <div class="input-group-append">
              <span><i style="padding-top:15px;padding-left:10px;" class="fas fa-search"></i></span>
            </div>
          </div></td>
        </tr>
        <tr *ngFor="let entry of this.ItemsToShow|name:nom:'name'|type:type:'type'|date:datum:'createdDate'|tag:tag:'tags'"  (click)="openEntry(entry)" class="gradeX">
          <td>{{entry.name}}</td>
          <td>
            {{getType(entry)}}
          </td>
          <td>{{entry.createdDate.split('T')[0]}}</td>
          <td>{{entry.tags}}</td>
        </tr>
        </tbody>
      </table>
      <div class="row col-md-12">
        <div class="paginationComponent" style="margin-left:25%;">
          <pagination
            [item-can-change]="true"
            [indexSelectedItem]="navigationState.paginationNumber"
            [item-by-page]="this.selectedResultsPerPage"
            [total-nb-respondents]="getFoundItemsLength()"
            (beforePageChange)="onBeforePageChange($event)"
            (go)="onBeforePageChange($event)"></pagination>
        </div>
      </div>
    </div>
  `,
  styles:[`

    tr td {
      font-family: Helvetica;
      font-weight: bold;
    }

    tr:hover {
      background: -webkit-linear-gradient(top, #648bf5, #2866f2);
      background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
      border-top: 1px solid #5a82eb;
      border-bottom: 1px solid #1758e7;
    }

    tr:hover td{
      color: #ffffff;

    }

    .demo {
    margin: 4em auto;
  }

  .dataTables_length label {
    float: left;
    text-align: left;
  }
  .dataTables_length select {
    width: 75px;
  }

  .dataTables_filter label {
    float: right;
  }

  .dataTables_info {
    padding-top: 26px;
  }

  .dataTables_paginate {
    float: right;
    margin: 0;
  }

  table.table {
    clear: both;
    margin-bottom: 6px !important;
    max-width: none !important;
  }
  table.table thead .sorting,
  table.table thead .sorting_asc,
  table.table thead .sorting_desc,
  table.table thead .sorting_asc_disabled,
  table.table thead .sorting_desc_disabled {
    cursor: pointer;
    *cursor: hand;
  }
  table.dataTable th:active {
    outline: none;
  }

  /* Scrolling */
  .dataTables_scrollHead table {
    margin-bottom: 0 !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .dataTables_scrollHead table thead tr:last-child th:first-child, .dataTables_scrollHead table thead tr:last-child td:first-child {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .dataTables_scrollBody table {
    border-top: none;
    margin-bottom: 0 !important;
  }
  .dataTables_scrollBody table tbody tr:first-child th, .dataTables_scrollBody table tbody tr:first-child td {
    border-top: none;
  }

  .dataTables_scrollFoot table {
    border-top: none;
  }

  /*
   * TableTools styles
   */
  .table tbody tr.active td, .table tbody tr.active th {
    background-color: #08C;
    color: white;
  }
  .table tbody tr.active:hover td, .table tbody tr.active:hover th {
    background-color: #0075b0 !important;
  }

  .table-striped tbody tr.active:nth-child(odd) td, .table-striped tbody tr.active:nth-child(odd) th {
    background-color: #017ebc;
  }

  table.DTTT_selectable tbody tr {
    cursor: pointer;
    *cursor: hand;
  }

  .DTTT .btn {
    color: #333 !important;
    font-size: 12px;
  }
  .DTTT .btn:hover {
    text-decoration: none !important;
  }

  ul.DTTT_dropdown.dropdown-menu li:hover a {
    background-color: #0088cc;
    color: white !important;
  }

  /* TableTools information display */
  .DTTT_print_info.modal {
    height: 150px;
    margin-top: -75px;
    text-align: center;
  }
  .DTTT_print_info h6 {
    font-weight: normal;
    font-size: 28px;
    line-height: 28px;
    margin: 1em;
  }
  .DTTT_print_info p {
    font-size: 14px;
    line-height: 20px;
  }

  /*
   * FixedColumns styles
   */
  div.DTFC_LeftHeadWrapper table,
  div.DTFC_LeftFootWrapper table,
  table.DTFC_Cloned tr.even {
    background-color: white;
  }

  div.DTFC_LeftHeadWrapper table {
    margin-bottom: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  div.DTFC_LeftHeadWrapper table thead tr:last-child th:first-child,
  div.DTFC_LeftHeadWrapper table thead tr:last-child td:first-child {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  div.DTFC_LeftBodyWrapper table {
    border-top: none;
    margin-bottom: 0 !important;
  }

  div.DTFC_LeftBodyWrapper tbody tr:first-child th,
  div.DTFC_LeftBodyWrapper tbody tr:first-child td {
    border-top: none;
  }

  div.DTFC_LeftFootWrapper table {
    border-top: none;
  }
  `]
})

export class SearchComponent implements OnInit {

  @Input() projectsList:Project[];

  private errorMessage:string;

  private navigationState: DataNavigationState;

  private foundItems:Array<Terminal |Project|Questionnaire>;

  private ItemsToShow:Array<Terminal |Project|Questionnaire> = new Array<Terminal|Project|Questionnaire>();

  private _pageNumber = 1;

  private selectedResultsPerPage =25;

  type = '';
  datum = '';
  nom = '';
  tag='';

  before = false;
  after = false;

  constructor(private _projectService:ProjectService,private _router: Router,private _activatedRouter: ActivatedRoute,) {if(this.projectsList == null) {
    this.navigationState = new DataNavigationState();
  }}

ngOnInit(): void {
  this._projectService.getProjects()
    .subscribe(
      projects => {
        this.foundItems = new Array<Terminal |Project|Questionnaire>();
        console.log(this.projectsList);

        const proj:Project[] = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(projects,Project);
        let quest:Questionnaire[] = [];
        let term:Terminal[] = [];

        for (let i = 0; i < proj.length; i++) {
         /* const pro = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(projects[i],Project);
          proj.push(pro);*/
          quest = quest.concat(proj[i].questionnaires);
          console.log('');
        }
        for(const q of quest) {
          term = term.concat(q.terminals);
        }

        this.foundItems = this.foundItems.concat(proj);
        this.foundItems = this.foundItems.concat(quest);
        this.foundItems = this.foundItems.concat(term);
        this.navigationState.paginationNumber = this._pageNumber;
        this.navigateToPage(1);
      },
      error => this.errorMessage = <any>error);
  }


  private navigateToPage(pageNumber:number) {
    let startIndex:number = pageNumber;
    if(pageNumber!==0) {
      startIndex =  pageNumber-1;
    }
    this.getItems(startIndex*this.selectedResultsPerPage,(startIndex*this.selectedResultsPerPage)+this.selectedResultsPerPage);

  }

  onBeforePageChange($event:ClickEvent) {
    if ( $event.index > 0  ) {
      this._pageNumber = $event.index;
      this.setPaginationNumber();
      const startIndex = this._pageNumber -1;
      this.getItems(startIndex*this.selectedResultsPerPage,(startIndex*this.selectedResultsPerPage)+this.selectedResultsPerPage);
    }
  }


  setPaginationNumber() {
    this.navigationState.paginationNumber = this._pageNumber;
  }

  private getItems(start:number,end:number) {

    this.ItemsToShow.length = 0;
    for(let i = start;i<end;i++) {
      if(i < this.foundItems.length) {
        this.ItemsToShow.push(this.foundItems[i]);
      } else {break;}
    }
  }

  backToRespondentList(page:number) {

    this.navigateToPage(page);
  }

  onSelected(event:any) {
    this.selectedResultsPerPage = event.target.value;
    this.navigateToPage(1);
  }

  private getFoundItemsLength():number {
    if(this.foundItems != null) {
      return this.foundItems.length;
    } else {
      return 0;
    }
  }

  private getType(entry:(Project|Questionnaire|Terminal)):string {

    if(entry instanceof Project) {
      return 'Project';
    } else if (entry instanceof Questionnaire) {
      return 'Questionnaire';
    } else {
      return entry.type;
    }
  }

  private openEntry(entry: (Project|Questionnaire|Terminal)) {
    console.log(this._activatedRouter.parent);
    if(entry instanceof Questionnaire) {
      this._router.navigate(['/project',entry.projectId,entry.id]);
    } else if(entry instanceof Project) {
      this._router.navigate(['/project',entry.id]);
    }
  }
}
